import React, {
    useEffect,
    useState,
} from 'react'
import { useSNAxios } from '../../hooks/use-axios'
import OverlayLoader from '../../components/shared/overlay-loader'
import Modal from '../../components/modal'
import Icon from '../../admin/components/icon'
import { ICONS } from '../../admin/components/icon/icons'
import Button from '../../front/components/shared/sn-button'
import { useTranslation } from 'react-i18next'
import SportForm from './sport-form'

/**
 * Super admin page for sport editing
 * @return {JSX.Element}
 * @constructor
 */
const SuperAdminSport = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [modalItem, setModalItem] = useState(null)
    const [sports, setSports] = useState([])
    const { t } = useTranslation()

    useEffect(() => {
        loadSports()
    }, [])

    /**
     * Load sports from API
     */
    const loadSports = () => {
        setIsLoading(true)

        useSNAxios('/sport-categories')
            .then(({ data }) => setSports(data.data))
            .then(() => setIsLoading(false))
    }

    /**
     * Edit modal item
     * @param {string} key
     * @param {string} value
     */
    const editModalItem = (key, value) => {
        let modalItemEdit = { ...modalItem }
        modalItemEdit[key] = value

        return setModalItem(modalItemEdit)
    }

    /**
     * Create empty sport
     */
    const createEmptySport = () => {
        setModalItem({
            original_name: '',
        })
    }

    /**
     * On save sport form
     */
    const saveSportForm = () => {
        setIsLoading(true)
        setModalItem(null)

        const dataToSave = {
            ...modalItem,
            name: modalItem.original_name,
            image: modalItem?.imageToSave || null,
        }

        useSNAxios('/sport/edit', dataToSave, 'put')
            .then(() => loadSports())
    }

    return (
        <div>
            <div>
                <h3>Jak to funguje</h3>
                <ul>
                    <li>Ve sloupci s názvem sportu je v prvním řádku název sportu <i>z databáze</i> a ve druhém řádku je název sportu <i>z lokalise</i> => tyto názvy by se měly shodovat</li>
                    <li>Po rozkliknutí detailu sportu se dá upravit jen název v databázi => sport v lokalise se dá nalézt pomocí odkazu v nadpisu "Název v lokalise"</li>
                    <li>Klíč pro sport je v lokalise <b>vždy</b> jako <b>sport_</b> a <i>ID sportu</i> (první sloupec)</li>
                    <li>Změna v lokalise se provede při dalším vydání systému. Do té doby se budou zobrazovat jen sporty česky, resp. v původním znění před změnou</li>
                    <li>Názvy sportů jsou pro všechny systémy stejné, nelze udělat jiný název např. pro Ostravu a jiný pro Cheb</li>
                </ul>
            </div>

            <Button
                className="btn btn-outline-primary"
                onClick={createEmptySport}
            >
                Přidat nový sport
            </Button>

            {sports?.map?.(sport => (
                <div className="d-flex align-items-center justify-content-between flex-row border-bottom my-1 pb-1">
                    <div className="d-flex align-items-center justify-content-between flex-row w-50">
                        <div>{sport.id}</div>
                        <div className="d-flex align-items-center justify-content-center flex-column">
                            <div>{sport.original_name}</div>
                            <small className="font-weight-bold">{t(`sport_${sport.id}`)}</small>
                        </div>
                        <div>
                            <img
                                src={sport.image_path || '/images/default-sport.png'}
                                alt=""
                                className="object-contain height-30px w-100"
                            />
                        </div>
                    </div>
                    <Button
                        className="btn btn-outline-color-gray-dark-3 btn-sm"
                        onClick={() => setModalItem(sport)}
                        title={t('edit')}
                    >
                        <Icon icon={ICONS.PENCIL2} className="text-color-gray-dark-1" />
                    </Button>
                </div>
            ))}

            {modalItem && (
                <Modal
                    handleHideModal={() => setModalItem(null)}
                    description={modalItem?.original_name}
                    content={() => (
                        <SportForm
                            formData={modalItem}
                            setFormData={editModalItem}
                            saveSportForm={saveSportForm}
                        />
                    )}
                />
            )}
            {isLoading && <OverlayLoader />}
        </div>
    )
}


export default SuperAdminSport
